import { getTheme, IRawStyle, IStackStyles } from "@fluentui/react";
import React from "react";

import { Stack, StackProps } from "./Stack";

const theme = getTheme();

const defaultRootStyles: IRawStyle = {
    marginBottom: 20,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
    paddingBottom: 20,
    backgroundColor: theme.palette.white,
    boxShadow: theme.effects.elevation8
};

export type ElevatedStackProps = React.PropsWithChildren<{
    styles?: IStackStyles;
    horizontalAlign?: StackProps["horizontalAlign"];
    testId?: string;
    isLoading?: boolean;
}>;

export const ElevatedStack: React.FunctionComponent<ElevatedStackProps> = (props: ElevatedStackProps) => {
    const propsStyles = props.styles;
    const propsRootStyles = (props.styles?.root || {}) as IRawStyle;

    return (
        <Stack
            data-testid={props.testId}
            data-testisloading={props.isLoading}
            horizontalAlign={props.horizontalAlign}
            styles={{ ...propsStyles, root: { ...defaultRootStyles, ...propsRootStyles } }}
        >
            <Stack.Item>{props.children}</Stack.Item>
        </Stack>
    );
};
